(() => {
  const root = window.Shopify?.routes?.root || '/';
  const inFlight = new WeakSet();

  async function load(slot) {
    const productId = slot.dataset.productId;
    if (!productId || slot.dataset.rnLoaded === productId || inFlight.has(slot)) return;
    inFlight.add(slot);
    try {
      const url = new URL(root + 'recommendations/products', window.location.origin);
      url.searchParams.set('section_id', 'rn-cart-recommendations');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '3');
      url.searchParams.set('intent', 'related');
      const response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const results = parsed.querySelector('.rn-cart-recs__results');
      slot.replaceChildren(...(results ? Array.from(results.childNodes) : []));
      slot.dataset.rnLoaded = productId;
    } catch (error) {
      slot.dataset.rnLoaded = productId;
    } finally {
      inFlight.delete(slot);
    }
  }

  function scan() {
    document.querySelectorAll('[data-rn-recs]').forEach((slot) => {
      if (!slot.closest('cart-drawer') || slot.closest('cart-drawer.active')) load(slot);
    });
  }

  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-rn-variant-select]');
    if (!select) return;
    const button = select.closest('.rn-cart-recs__detail')?.querySelector('[data-rn-quick-add]');
    if (!button) return;
    button.dataset.rnQuickAdd = select.value;
    button.disabled = !select.value;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rn-quick-add]');
    if (!button || !button.closest('cart-drawer')) return;
    const drawer = button.closest('cart-drawer');
    const errorTarget = button.closest('[data-rn-recs]')?.querySelector('[data-rn-error]');
    if (errorTarget) errorTarget.textContent = '';
    button.disabled = true;
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(button.dataset.rnQuickAdd),
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || button.dataset.rnErrorText);
      drawer.renderContents(data);
    } catch (error) {
      if (errorTarget) errorTarget.textContent = error.message;
      button.disabled = false;
    }
  });
})();
